export default "__VITE_ASSET__BBtkxxym__"